export const routes = (prefix = `inpatients`) => [
    {
        path: `/${prefix}/list`,
        name: `${prefix}.list.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.list.index`,
                PageDescription: `Inpatient - Patient List`,
            },
        },
    },
];
